var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.checkVal(_vm.value))?_c('el-tag',{attrs:{"type":_vm.getTagType(_vm.value),"size":"mini"}},[_vm._v(_vm._s(_vm.getTagText(_vm.value)))]):_vm._e(),(
      _vm.relType == 'tags' &&
      _vm.value != null &&
      _vm.value != undefined &&
      _vm.value.length > 0
    )?_c('div',_vm._l((_vm.value),function(item,idx){return _c('span',{key:idx,staticStyle:{"margin-right":"8px"}},[_c('el-tag',{attrs:{"type":_vm.getTagType(item),"size":"mini"}},[_vm._v(_vm._s(_vm.getTagText(item)))])],1)}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }